import { Staff } from "@towersystems/roam-common/lib/generated-types";
import { QUERY_STAFF_USERS_LIST } from "../../common";
import { useLoadMoreList } from "../../../../utilities/load-more-list";
import React from "react";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { SettingsManageUsersRootParamList } from "../../../../types";
import {
  Badge,
  Button,
  Text,
  Divider,
  FlatActionList,
  FlatListSearchable,
  Page,
} from "@towersystems/roam-common-native";
import { View } from "react-native-ui-lib";
import { useFocusEffect } from "@react-navigation/native";

export type SettingsListStaffUsersScreenProps = NativeStackScreenProps<
  SettingsManageUsersRootParamList,
  "SettingsListStaffUsersScreen"
>;

export const SettingsListStaffUsersScreen = ({
  navigation,
}: SettingsListStaffUsersScreenProps) => {
  const loadMoreList = useLoadMoreList<Staff>({
    initialLoad: false,
    query: QUERY_STAFF_USERS_LIST,
    resultKey: "staffs",
    sort: { updatedAt: "DESC" },

    variableFormatter: (variables) => {
      return {
        options: {
          ...variables,
          limit: 9999,
        },
      };
    },
  });

  React.useEffect(() => {
    navigation.setOptions({
      headerRight: ({}) => (
        <Button
          isAction
          size="compact"
          label="New staff member"
          onPress={() => navigation.navigate("SettingsCreateStaffMemberScreen")}
        ></Button>
      ),
    });
  }, []);

  useFocusEffect(
    React.useCallback(() => {
      loadMoreList.loadMore(
        {
          filter: {},
        },
        true,
      );
    }, []),
  );

  const renderItem = React.useCallback(({ item }: { item: Staff }) => {
    return (
      <FlatActionList.RenderItem
        item={{
          key: item.id,
          title: item.fullName,
          subTitle: item.emailAddress,
          titleContent({ title, subTitle }) {
            return (
              <View>
                <View flex row centerV>
                  <Text variant="heading" fontWeight="medium">
                    {title}
                  </Text>
                  <View marginL-8>
                    {!item.userId && <Badge>No user account</Badge>}
                  </View>
                </View>
                <View>{subTitle}</View>
              </View>
            );
          },
          onPress: () => {
            navigation.navigate(
              !item.userId
                ? "SettingsUpgradeStaffToUserAccountScreen"
                : "SettingsEditStaffMemberScreen",
              {
                staffId: item.id,
              },
            );
          },
        }}
      ></FlatActionList.RenderItem>
    );
  }, []);

  console.log(loadMoreList.items);

  return (
    <Page
      title="Staff members"
      secondaryTitle="Manage staff members and their access"
      scrollable={true}
    >
      <FlatListSearchable
        renderSearchBarHeader={() => <View />}
        ItemSeparatorComponent={Divider}
        renderItem={renderItem}
        data={loadMoreList.items ?? []}
      />
    </Page>
  );
};
